// JS for block-specific behavior only
console.log('res stats with quote block loaded');